export default {
  GENERATE_DELIVERY_WELIVERY: `#graphql
  mutation generateDeliveryWelivery($order: String!, $isChange: Boolean!, $packageCount: Int) {
    generateDeliveryWelivery(order: $order, isChange: $isChange, packageCount: $packageCount) {
      idWelivery,
      weliveryReference,
      dateWelivery,
      weliveryPackageCount,
      tracking,
      conveyor,
      cost
    }
  }`,

  SELECT_CONVEYOR: `#graphql
  mutation selectDeliveryConveyor($order: String!, $conveyor: String!) {
    selectDeliveryConveyor(order: $order, conveyor: $conveyor)
  }`,

  GET_TRACKING_WELIVERY: `#graphql
  query getTrackingWelivery($tracking: String!) {
    getTrackingWelivery(tracking: $tracking) { code description date hour }
  }`,

  GENERATE_LABELS_WELIVERY: `#graphql
  mutation generateLabelsWelivery($deliveries: [String!]!) {
    generateLabelsWelivery(deliveries: $deliveries)
  }`
}



// WEBPACK FOOTER //
// ./src/graphql/welivery.js